import React from 'react'

function Passentriesreport() {
  return (
    <div>Passentriesreport</div>
  )
}

export default Passentriesreport